import { OCCUPATION_LIST, OCCUPATION_ADDEDIT, OCCUPATION_CHANGE_STATUS, OCCUPATION_DELETE } from "../../api/constApi";
import { authHeader } from "./authHeader";
import { apiInstance } from "./axiosApi";


export const occupationListApi = (payload) => {
    return apiInstance.post(OCCUPATION_LIST, payload, {
        headers: authHeader(),
    });
};

export const occupationChangeStatusApi = (payload) => {
    return apiInstance.post(OCCUPATION_CHANGE_STATUS, payload, {
        headers: authHeader(),
    });
};

export const AddEditOccupationApi = (payload) => {
    return apiInstance.post(OCCUPATION_ADDEDIT, payload, {
        headers: authHeader(),
    });
};

export const occupationDeleteApi = (payload) => {
    return apiInstance.post(OCCUPATION_DELETE, payload, {
        headers: authHeader(),
    });
};